import { root, id } from './create';

export const create = {
  ...root,
  id: id,
};
